import "../../assets/css/custom.css";
import "./chatstyles.css";
import AudioIcon from "../../assets/images/icons/audio-icon.png";
import DataGridDemo from "./DataGridDemo";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import IconButton from "@mui/material/IconButton";
import Pausebtn from "../../assets/images/icons/pause.png";
import PlayAgainbtn from "../../assets/images/icons/play-again.png";
import Playbtn from "../../assets/images/icons/play-button.png";
import React, { useEffect, useRef, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import classnames from "classnames";
import { FaEye } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";
import { Col, Row } from "reactstrap";

import {
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
} from 'reactstrap';

const StarterPage = ({ conversationData = {}, dataTabs }) => {
  document.title = 'Linc Quality Hub';
  // console.log('datatabs', dataTabs);

  const [selectedItem, setSelectedItem] = useState(null);
  const [viewType, setViewType] = useState('none');
  const [expandedMailSection, setExpandedMailSection] = useState('all'); // State for mail section
  const [lastViewType, setLastViewType] = useState('none');
  const [isPlaying, setIsPlaying] = useState(false);
  const [modalCenter2, setModalCenter2] = useState(false);
  const audioRef = useRef(null);

  const audios = dataTabs.audio_calls || [];
  const videos = dataTabs.video_calls || [];
  const messages = dataTabs.messages || [];
  const mails = dataTabs.mails || [];
  const details = dataTabs || [];
  // console.log('tc conversationData', audios);

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const staticData = {
    transcription: [
      {
        speaker: 'Speaker A',
        speakerClass: 'speaker-a',
        line: 'Hello, how are you today?',
      },
      {
        speaker: 'Speaker B',
        speakerClass: 'speaker-b',
        line: "I'm doing well, thank you! How about you?",
      },
      {
        speaker: 'Speaker A',
        speakerClass: 'speaker-a',
        line: "I'm great, thanks for asking!",
      },
      {
        speaker: 'Speaker B',
        speakerClass: 'speaker-b',
        line: "Good to hear! What's the plan for today?",
      },
      {
        speaker: 'Speaker A',
        speakerClass: 'speaker-a',
        line: 'I was thinking of discussing the project updates.',
      },
      {
        speaker: 'Speaker B',
        speakerClass: 'speaker-b',
        line: "Sounds good, let's dive into it.",
      },
    ],
  };

  //Bar chart
  const [progressOptions, setProgressOptions] = useState({});
  // const getColorByScore = (score) => {
  //   if (score >= 80) return '#006400'; // Dark Green
  //   if (score >= 50) return '#90EE90'; // Light Green
  //   return '#FFD700'; // Yellow
  // };

      const getColorByScore = (score) => ({
        linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
        stops:
          score < 50
            ? [
                [0, '#FFD6D6'], // light red
                [1, '#FF8A8A'],
              ]
            : score < 80
            ? [
                [0, '#FFF7CC'], // light yellow
                [1, '#FFE066'],
              ]
            : [
                [0, '#D1F7C4'], // light green
                [1, '#90EE90'],
              ],
      });


  useEffect(() => {
    if (!selectedItem) return;

    const dynamicScores = [
      selectedItem.engagement_score,
      selectedItem.clarity_score,
      selectedItem.responsiveness_score,
      selectedItem.call_coverage_score,
      selectedItem.student_sentiment_score,
      selectedItem.overall_call_quality_score,
    ];

    const categories = [
      'Engagement Score',
      'Clarity Score',
      'Responsiveness Score',
      'Call Coverage Score',
      'Student Sentiment',
      'Overall Call Quality Score',
    ];

    setProgressOptions({
      chart: {
        type: 'bar',
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: categories,
      },
      yAxis: {
        title: {
          text: '',
        },
        max: 100,
      },
      series: [
        {
          name: 'Scores',
          color: '#fff',
          pointWidth: 10,
          data: dynamicScores.map((score) => ({
            y: Number(score) || 0,
            color: getColorByScore(score),
          })),
          dataLabels: {
            enabled: true,
            format: '{point.y}',
            style: {
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#000',
            },
          },
        },
      ],
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        chartOptions: {
          title: {
            text: 'Call Quality Breakdown',
          },
        },
      },
    });
  }, [selectedItem]);

  // tbas-------------
  const [customActiveTab, setcustomActiveTab] = useState('1');

  // State to manage the active tab
  const [activeTab, setActiveTab] = useState('transcription');
  const [activeTabVideo, setActiveTabVideo] = useState('transcriptionvideo');

  // Function to handle tab change
  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  const toggleTabVideo = (tabVideo) => {
    setActiveTabVideo(tabVideo);
  };

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
      //  setViewType(tab);
    }
  };

  // modal-------------
  const [modal_center, setmodal_center] = useState(false);
  function tog_center() {
    setmodal_center(!modal_center);
  }
  const [modal_center1, setmodal_center1] = useState(false);
  function tog_center1() {
    setmodal_center1(!modal_center1);
  }
  const [modal_center2, setmodal_center2] = useState(false);
  function tog_center2() {
    setmodal_center2(!modal_center2);
  }

  const [currentTime, setCurrentTime] = useState(0); // State to track current time of audio
  const [duration, setDuration] = useState(0); // State to track total duration of audio

  // Update the current time state as the audio plays
  const handlePlayPauseClick = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play().catch((error) => {
          console.error('Error playing audio:', error);
          setIsPlaying(false); // Reset play state on error
        });
        setIsPlaying(true);
      }
    }
  };

  const handleStopClick = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0; // Reset playback position
      setIsPlaying(false);
    }
  };

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
    }
  };

  const handleProgressClick = (e) => {
    const { clientX } = e;
    const { left, width } = e.currentTarget.getBoundingClientRect();
    const clickPosition = clientX - left;
    const percentage = clickPosition / width;
    audioRef.current.currentTime = percentage * duration; // Set current time based on click position
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Define options for formatting
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
    };

    return date.toLocaleString('en-US', options);
  };

  function formatDuration(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    const formattedSeconds =
      remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;

    return `${minutes}:${formattedSeconds}`;
  }

  const formattedaudioDataArray = audios.map((audio, index) => {
    // // console.log(audio)
    // console.log('{audiokpi', audio);

    const speakerNames = [
      ...new Set(audio.transcription.map((line) => line.speaker.split(' ')[3])),
    ];
    // // console.log(speakerNames);

    const speakerClasses = audio.transcription.map((line) => {
      console.warn('Speak', audio.teacher_name, 'speaker ', line.speaker);
      let teachName = audio.teacher_name;
      return {
        speakerClass:
          line.speaker?.toLowerCase() === teachName?.toLowerCase()
            ? 'speaker-a'
            : 'speaker-a',
        line: line.text,
        speaker: line.speaker,
        starttime: Math.round(line.start * 100) / 100, // Round to 2 decimal places
        endtime: Math.round(line.end * 100) / 100, // Round to 2 decimal places
      };
    });

    return {
      id: index + 1,
      fk_file_id: audio.fk_file_id,
      file_name: audio.file_name,
      type: 'audio',
      created_on: formatDate(audio.created_at),
      duration: formatDuration(audio.duration) || 0,
      transcription: speakerClasses,
      speakertype: speakerClasses,
      audio_file: audio.file_url,
      summary: audio.summary ? audio.summary : '',
      Topics: audio.topics ? audio.topics : '',
      question: audio.question_answers ? audio.question_answers : '',
      call_quality_score: audio.call_quality_score,
      call_quality: audio.call_quality,
      performance: audio.performance,
      TopicsDiscuessed: audio.topics,
      KPI: audio.kpi ? audio.kpi : '',
      student_name: audio.student_name,
      teacher_name: audio.teacher_name,
      knowledge_gaps_identified: audio.summary?.knowledge_gaps_identified ?? '',
      progress_check_in: audio.summary?.discussion_points?.progress_check_in,
      assessment_discussion:
        audio.summary?.discussion_points?.assessment_discussion,
      audio_video_issues: audio.summary?.discussion_points?.audio_video_issues,
      draft_discussion: audio.summary?.discussion_points?.draft_discussion,
      next_call_setup: audio.summary?.discussion_points?.next_call_setup,
      recording_compliance:
        audio.summary?.discussion_points?.recording_compliance,
      callQualityKpi: audio.call_quality?.kpi ?? '',

      call_coverage_score:
        audio.call_quality?.call_quality_analysis?.call_coverage_score ?? '',
      clarity_score:
        audio.call_quality?.call_quality_analysis?.clarity_score ?? '',
      engagement_score:
        audio.call_quality?.call_quality_analysis?.engagement_score ?? '',
      overall_call_quality_score:
        audio.call_quality?.call_quality_analysis?.overall_call_quality_score ??
        '',
      responsiveness_score:
        audio.call_quality?.call_quality_analysis?.responsiveness_score ?? '',
      student_sentiment_score:
        audio.call_quality?.call_quality_analysis?.student_sentiment_score ??
        '',
    };
  });

  const formattedvideoDataArray = videos.map((video, index) => {
    const speakerNames = [
      ...new Set(video.transcription.map((line) => line.speaker.split(' ')[3])),
    ];
    let teachName = video.teacher_name;

    // // console.log(speakerNames);
    // console.log('video data', video);
    const speakerClasses = video.transcription.map((line) => {
      return {
        speakerClass:
          line.speaker?.toLowerCase() === teachName?.toLowerCase()
            ? 'speaker-a'
            : 'speaker-a',
        line: line.text,
        speaker: line.speaker,
        starttime: Math.round(line.start * 100) / 100, // Round to 2 decimal places
        endtime: Math.round(line.end * 100) / 100, // Round to 2 decimal places
      };
    });

    return {
      id: index + 1,
      fk_file_id: video.fk_file_id,
      file_name: video.file_name,
      type: 'video',
      created_on: formatDate(video.created_at),
      duration: formatDuration(video.duration) || 0,
      transcription: speakerClasses,
      speakertype: speakerClasses,
      video_file: video.file_url,
      summary: video.summary ? video.summary : '',
      Topics: video.topics,
      question: video.question_answers,
      call_quality_score: video.call_quality_score,
      call_quality: video.call_quality,
      performance: video.performance,
      TopicsDiscuessedvideo: video.topics,
      KPI: video.kpi ? video.kpi : '',
      student_name: video.student_name,
      teacher_name: video.teacher_name,
      knowledge_gaps_identified: video.summary?.knowledge_gaps_identified ?? '',
      progress_check_in: video.summary?.discussion_points?.progress_check_in,
      assessment_discussion:
        video.summary?.discussion_points?.assessment_discussion,
      audio_video_issues: video.summary?.discussion_points?.audio_video_issues,
      draft_discussion: video.summary?.discussion_points?.draft_discussion,
      next_call_setup: video.summary?.discussion_points?.next_call_setup,
      recording_compliance:
        video.summary?.discussion_points?.recording_compliance,
      callQualityKpi: video.call_quality?.kpi ?? '',

      call_coverage_score:
        video.call_quality?.call_quality_analysis?.call_coverage_score ?? '',
      clarity_score:
        video.call_quality?.call_quality_analysis?.clarity_score ?? '',
      engagement_score:
        video.call_quality?.call_quality_analysis?.engagement_score ?? '',
      overall_call_quality_score:
        video.call_quality?.call_quality_analysis?.overall_call_quality_score ??
        '',
      responsiveness_score:
        video.call_quality?.call_quality_analysis?.responsiveness_score ?? '',
      student_sentiment_score:
        video.call_quality?.call_quality_analysis?.student_sentiment_score ??
        '',
    };
  });

  //data points
  const rows = [
    {
      label: 'Progress Check-in',
      value: selectedItem?.progress_check_in,
      title:
        "Did the teacher check-in on the student's progress with the course",
    },
    {
      label: 'Assessment Discussion',
      value: selectedItem?.assessment_discussion,
      title: 'Was an assessment discussed',
    },
    {
      label: 'Draft Discussion',
      value: selectedItem?.draft_discussion,
      title: 'Was an assessment draft discussed shared and discussed',
    },
    {
      label: 'Next Call Setup',
      value: selectedItem?.next_call_setup,
      title: 'Did the teacher setup the next call',
    },
    {
      label: 'Audio / video Issues',
      value: selectedItem?.audio_video_issues,
      title: ' Did the student struggle with voice / call quality ',
    },
    {
      label: 'Recording Compliance',
      value: selectedItem?.recording_compliance,
      title: 'Did the teacher inform the call is being recorded',
    },
  ];

  const transformData = (data) => {
    // // console.log("data1", data)
    const groupedMessages = {};

    const formatTime = (timeString) => {
      // Split time string to get hours, minutes, and seconds
      const [hours, minutes] = timeString.split(':');

      // Convert hours, minutes, and seconds to 24-hour format
      return `${hours}:${minutes}`;
    };
    // Iterate over each date in the grouped data
    Object.entries(data).forEach(([date, messages]) => {
      // Initialize the array for this date if it doesn't exist
      if (!groupedMessages[date]) {
        groupedMessages[date] = [];
      }

      // Sort messages by time
      messages.sort(
        (a, b) =>
          new Date(`1970-01-01T${a.time}Z`) - new Date(`1970-01-01T${b.time}Z`),
      );

      // Iterate over sorted messages
      messages.forEach((message, index) => {
        // Format time to 12-hour format with AM/PM
        const formattedTime = formatTime(message.time);

        groupedMessages[date].push({
          id: index + 1, // Use index for unique ID within the date
          sender: message.from_student ? 'User A' : 'User B',
          name: message.from_student
            ? details.student
              ? details.student
              : 'Student'
            : details.teacher
            ? details.teacher
            : 'Fellow',
          content: message.message,
          date: formattedTime,
        });
      });
    });

    // Sort dates in ascending order
    const sortedGroupedMessages = Object.fromEntries(
      Object.entries(groupedMessages).sort(
        ([a], [b]) => new Date(a) - new Date(b),
      ),
    );

    return sortedGroupedMessages;
  };

  const formatMails = Object.entries(mails).map(([threadId, emails], index) => {
    const thread = emails.map((email, emailIndex) => ({
      id: emailIndex + 1,
      subject: email.subject,
      mail_from: email.from_student ? details.student : details.teacher,
      mail_To: email.from_student ? details.teacher : details.student,
      type: email.from_student ? 'received' : 'sent',
      body: email.body,
      date: formatDate(email.created_at),
    }));

    // Get the most recent email for this thread
    const latestEmail = thread[0]; // Assuming emails are sorted from newest to oldest

    return {
      id: latestEmail.id,
      threadId,
      subject: latestEmail.subject,
      date: latestEmail.date,
      emails: thread,
    };
  });

  const groupedMessages = transformData(messages);

  // Filter sent and received mails
  const sentMails = formatMails.filter((email) => email.type === 'sent');
  const receivedMails = formatMails.filter(
    (email) => email.type === 'received',
  );

  const toggleMailSection = () => {
    setExpandedMailSection(expandedMailSection === 'all' ? null : 'all');
  };
  const handlemailClick = (email) => {
    setSelectedItem(email);
    setModalCenter2(true); // Open modal when clicking "More"
  };

  const handleRowClick = (row) => {
    // Handle row click logic (maybe open a detailed view of the email)
    // // console.log('Row clicked:', row);
  };

  // const handleRowClick = (item) => {
  //   setSelectedItem(item);
  // };

  const handleBackButtonClick = () => {
    setSelectedItem(null);
    setViewType(lastViewType);
    setIsPlaying(false);
  };

  const handleTabClick = (type) => {
    setLastViewType(type);
    setViewType(type);
    setSelectedItem(null);
    setExpandedMailSection(null); // Reset mail section when changing tab
    setIsPlaying(false);
  };

  const handleViewClick = (row) => {
    if (row.type === 'audio') {
      tog_center();
    } else {
      tog_center1();
    }
    setSelectedItem(row);

    // Perform action like navigation or showing a modal with details
  };

  const [selectedThread, setSelectedThread] = useState(null);

  const handleThreadView = (threadId) => {
    // Find the selected thread from the grouped data
    const thread = formatMails.find((item) => item.threadId === threadId);
    setSelectedThread(thread);
    setModalCenter2(true);
  };
  let topicsDiscussed = [];

  try {
    const raw = selectedItem?.TopicsDiscuessed;
    topicsDiscussed = typeof raw === 'string' ? JSON.parse(raw) : raw || [];
  } catch (e) {
    console.error('Failed to parse TopicsDiscuessedvideo:', e);
    topicsDiscussed = [];
  }

  let topicsDiscussedVideo = [];

  try {
    const raw = selectedItem?.TopicsDiscuessedvideo;
    topicsDiscussedVideo =
      typeof raw === 'string' ? JSON.parse(raw) : raw || [];
  } catch (e) {
    console.error('Failed to parse TopicsDiscuessedvideo:', e);
    topicsDiscussedVideo = [];
  }

  return (
    <React.Fragment>
      <div className="mt-0 conversation-wrapper">
        <div className="converstion-types">
          <Card className="mb-2">
            <CardBody>
              <CardTitle className="h4 mb-3">Conversation Types</CardTitle>

              <Nav tabs className="nav-tabs-custom nav-justified">
                <NavItem>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: customActiveTab === '1',
                    })}
                    onClick={() => {
                      toggleCustom('1');
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      {' '}
                      <i className="mdi mdi-microphone f-18 me-md-2"> </i>{' '}
                      <p className="d-md-block d-none">Audio Calls</p>
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: customActiveTab === '2',
                    })}
                    onClick={() => {
                      toggleCustom('2');
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      {' '}
                      <i className="mdi mdi-video f-18 me-md-2"></i>{' '}
                      <p className="d-md-block d-none">Video Calls</p>
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: customActiveTab === '3',
                    })}
                    onClick={() => {
                      toggleCustom('3');
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      {' '}
                      <i className="mdi mdi-message f-18 me-md-2"></i>{' '}
                      <p className="d-md-block d-none">Messages</p>
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: customActiveTab === '4',
                    })}
                    onClick={() => {
                      toggleCustom('4');
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      {' '}
                      <i className="mdi mdi-email f-18 me-md-2"></i>{' '}
                      <p className="d-md-block d-none">Mails</p>
                    </span>
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent
                activeTab={customActiveTab}
                className="p-0 pt-3 text-muted"
              >
                <TabPane tabId="1">
                  <div>
                    <DataGridDemo
                      columns={[
                        {
                          field: 'id',
                          headerName: 'S.No',
                          width: 100,
                          align: 'center',
                          headerAlign: 'left',
                          sortable: false, // Prevent sorting on S.No
                          renderCell: (params) =>
                            params.api.getRowIndexRelativeToVisibleRows(
                              params.id,
                            ) + 1,
                        },
                        {
                          field: 'file_name',
                          headerName: 'File Name',
                          minWidth: 400,
                          flex: 1,
                        },
                        {
                          field: 'call_quality_score',
                          headerName: 'Call Quality Score',
                          width: 200,
                          align: 'center',
                          headerAlign: 'left',
                        },
                        // {
                        //   field: "call_quality",
                        //   headerName: "Call Quality",
                        //   width: 200,
                        // },
                        {
                          field: 'performance',
                          headerName: 'Performance',
                          width: 200,
                        },
                        {
                          field: 'duration',
                          headerName: 'Duration (Min)',
                          width: 200,
                        },
                        { field: 'created_on', headerName: 'Date', width: 350 },
                        {
                          field: 'view',
                          headerName: 'View',
                          width: 150,
                          align: 'center',
                          headerAlign: 'center',
                          sortable: false,
                          renderCell: (params) => (
                            <IconButton
                              onClick={() => handleViewClick(params.row)}
                              color="primary"
                              type="button"
                              className="conv-view-btn"
                            >
                              <VisibilityIcon />
                            </IconButton>
                          ),
                        },
                      ]}
                      rows={formattedaudioDataArray}
                      // onRowClick={handleRowClick}
                    />

                    <Modal
                      size="xl"
                      isOpen={modal_center}
                      toggle={() => {
                        tog_center();
                      }}
                      centered
                      className="audio-trans-model"
                    >
                      <div className="modal-header">
                        <div>
                          <h4 className="modal-title f-18">
                            {selectedItem?.file_name}
                          </h4>
                          <p>Audio Call Transcript</p>
                          <p className="bold">
                            Student Name: {selectedItem?.student_name}
                          </p>
                          <p className="bold">
                            Teacher Name: {selectedItem?.teacher_name}
                          </p>
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            setmodal_center(false);
                            setSelectedItem(null);
                          }}
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body modal-bg-grey">
                        {selectedItem && customActiveTab === '1' && (
                          <div className="audio-player">
                            <div className="audio-track-wrapper mt-0">
                              {
                                !selectedItem.audio_file  ? 
                                <p>Session recording not available </p> :
                              <audio
                                controls
                                ref={audioRef}
                                src={selectedItem.audio_file}
                                onTimeUpdate={handleTimeUpdate}
                                onLoadedMetadata={handleLoadedMetadata}
                                controlsList="nodownload"
                              >
                                Your browser does not support the audio element.
                              </audio>
                              }
                            </div>

                            <div className="">
                              <Nav className="mb-0" tabs>
                                <NavItem>
                                  <NavLink
                                    className={
                                      activeTab === 'transcription'
                                        ? 'active'
                                        : ''
                                    }
                                    active={activeTab === 'transcription'}
                                    onClick={() => toggleTab('transcription')}
                                    style={{
                                      cursor: 'pointer',
                                      marginRight: '2px',
                                    }}
                                  >
                                    Call Transcript
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={
                                      activeTab === 'summary' ? 'active' : ''
                                    }
                                    active={activeTab === 'summary'}
                                    onClick={() => toggleTab('summary')}
                                    style={{
                                      cursor: 'pointer',
                                      marginRight: '3px',
                                    }}
                                  >
                                    Call Summary
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={
                                      activeTab === 'topics' ? 'active' : ''
                                    }
                                    active={activeTab === 'topics'}
                                    onClick={() => toggleTab('topics')}
                                    style={{
                                      cursor: 'pointer',
                                      marginRight: '3px',
                                    }}
                                  >
                                    Topics Discussed
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={
                                      activeTab === 'callquality'
                                        ? 'active'
                                        : ''
                                    }
                                    active={activeTab === 'callquality'}
                                    onClick={() => toggleTab('callquality')}
                                    style={{
                                      cursor: 'pointer',
                                      marginRight: '3px',
                                    }}
                                  >
                                    Call Quality
                                  </NavLink>
                                </NavItem>
                                {/* <NavItem>
                                  <NavLink
                                    className={activeTab === "kpi" ? "active" : ""}
                                    active={activeTab === "kpi"}
                                    onClick={() => toggleTab("kpi")}
                                    style={{ cursor: "pointer", marginRight: "3px" }}
                                  >
                                    KPI
                                  </NavLink>
                                </NavItem> */}
                                {/* <NavItem>
                                  <NavLink
                                    className={activeTab === "questonandresponse" ? "active" : ""}
                                    active={activeTab === "questonandresponse"}
                                    onClick={() => toggleTab("questonandresponse")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    Question & Responses
                                  </NavLink>
                                </NavItem> */}
                              </Nav>

                              <div>
                                {activeTab === 'transcription' && (
                                  <div className="audio chat-container">
                                    <div className=" d-flex flex-column">
                                      {/* {JSON.stringify(
                                        selectedItem.transcription,
                                      )} */}
                                      {selectedItem.transcription.map(
                                        (line, index) => (
                                          <div
                                            key={index}
                                            // className={`chat-bubble ${line.speakerClass} `}
                                            className={`chat-bubble ${
                                              !line.speaker.toLowerCase().trim().includes((selectedItem?.teacher_name || '').toLowerCase().trim())
                                                ? 'speaker-a'
                                                : 'speaker-b'
                                            } `}
                                          >
                                            <strong>{line.speaker}</strong>
                                            <br />
                                            {line.line}
                                            <br />
                                            <span>
                                              {line.starttime}s - {line.endtime}
                                              s
                                            </span>
                                            {}
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  </div>
                                )}
                                {activeTab === 'summary' && (
                                  <div className="trans-tab-content">
                                    <p className="f-16 mb-2">
                                      <strong>Call Summary:</strong>
                                    </p>
                                    {/* <p className="">The conversation covered organizing a follow-up call, discussing office hours, and clarifying key assessment details. The student, Annie May, expressed concerns about her time constraints due to her full-time teaching job and personal commitments. A follow-up call was scheduled for Friday at 7:30 PM, with support assured for the student's situation.</p> */}
                                    {/* <p>{selectedItem?.summary}</p> */}
                                    <div
                                      className="va-summary-main"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          selectedItem?.summary?.call_summary ||
                                          'No summary available.',
                                      }}
                                    ></div>
                                    <h4 className="bold mt-2">
                                      Discussion Points
                                    </h4>
                                    <div className="mt-2">
                                      <table className="bordered-table">
                                        <tbody>
                                          {/* {rows.map((row, index) => (
                                            <tr key={index}>
                                              <td className="pointer  align-items-center gap-2" style={{ position: "relative" }}>
                                                {row.label}
                                                <span
                                                  onMouseEnter={() => setHoveredIndex(index)}
                                                  onMouseLeave={() => setHoveredIndex(null)}
                                                  style={{ position: "relative", display: "inline-block", cursor: "pointer" }}
                                                >
                                                  <FaInfoCircle />
                                                  {hoveredIndex === index && (
                                                    <span className="tooltip-box">{row.title}</span>
                                                  )}
                                                </span>
                                              </td>
                                              <td>{row.value}</td>
                                            </tr>
                                          ))} */}
                                          {rows.map((row, index) => (
                                            <tr key={index}>
                                              <td>
                                                <span
                                                  className="position-relative d-inline-block"
                                                  onMouseEnter={() =>
                                                    setHoveredIndex(index)
                                                  }
                                                  onMouseLeave={() =>
                                                    setHoveredIndex(null)
                                                  }
                                                  style={{ cursor: 'pointer' }}
                                                >
                                                  {row.label}
                                                  {hoveredIndex === index && (
                                                    <span className="tooltip-box">
                                                      {row.title}
                                                    </span>
                                                  )}
                                                </span>
                                              </td>
                                              <td>{row.value}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                    <h4 className="bold mt-2">
                                      {' '}
                                      Knowledge Gaps Identified / Common Doubts
                                      Raised by student{' '}
                                    </h4>
                                    <div
                                      className="va-summary-main"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          selectedItem?.knowledge_gaps_identified ||
                                          'No summary available.',
                                      }}
                                    ></div>
                                  </div>
                                )}
                                {activeTab === 'topics' && (
                                  <div className="trans-tab-content">
                                    <p className="f-16 mb-2">
                                      <strong>Topics Discussed:</strong>
                                    </p>
                                    {/* <ul>
                                      <li>Follow-up call</li>
                                      <li>Office hours</li>
                                      <li>Assessments</li>
                                      <li>Student's schedule</li>
                                      <li>Teacher's support</li>
                                    </ul> */}
                                    <ul>
                                      {/* {selectedItem?.Topics?.length > 0 ? (
                                        selectedItem.Topics.map((topic, index) => (
                                          <li key={index}>{topic}</li>
                                        ))
                                      ) : (
                                        <li>Loading...</li>
                                      )} */}
                                      <div
                                        className="va-summary-main"
                                        // dangerouslySetInnerHTML={{
                                        //   __html: selectedItem?.Topics || "No Topics available."
                                        // }}
                                      ></div>
                                      {topicsDiscussed &&
                                        Object.entries(topicsDiscussed).map(
                                          ([topicName, qas], index) => (
                                            <div key={index} className="mb-3">
                                              <h5>{topicName}</h5>
                                              {qas.map((qa, qaIndex) => (
                                                <div
                                                  key={qaIndex}
                                                  className="mb-2"
                                                >
                                                  <p>
                                                    <strong>Q:</strong>{' '}
                                                    {qa.question}
                                                  </p>
                                                  <p>
                                                    <strong>A:</strong>{' '}
                                                    {qa.answer}
                                                  </p>

                                                  {/* Show A Mark if is_assessment_related is true */}
                                                  {qa.is_assessment && (
                                                    <p className="text-success">
                                                      <strong>A :</strong> ✓
                                                      Assessment Related
                                                    </p>
                                                  )}
                                                </div>
                                              ))}
                                            </div>
                                          ),
                                        )}
                                    </ul>
                                  </div>
                                )}
                                {activeTab === 'callquality' && (
                                  <div className="trans-tab-content">
                                    <p className="f-16 mb-2">
                                      <strong>Call Quality:</strong>
                                    </p>

                                    <Row className="g-2">
                                      <Col md={12} className="mb-2">
                                        <Card className="mb-0 h-100">
                                          <CardBody>
                                            <h5 className="f-16 d-flex  bold mb-3 ">
                                              Call Quality Rubric{' '}
                                            </h5>
                                            <HighchartsReact
                                              highcharts={Highcharts}
                                              options={progressOptions}
                                            />

                                            <h5 className="f-16 d-flex  bold mb-3 ">
                                              Session KPI:{' '}
                                            </h5>

                                            <div
                                              className="va-summary-main"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  selectedItem?.callQualityKpi ||
                                                  'No Call Quality Available.',
                                              }}
                                            ></div>
                                          </CardBody>
                                        </Card>
                                      </Col>
                                    </Row>
                                  </div>
                                )}

                                {activeTab === 'kpi' && (
                                  <div className="trans-tab-content">
                                    <p className="f-16 mb-2">
                                      <strong>Session KPI::</strong>
                                    </p>

                                    <ul>
                                      <div
                                        className="va-summary-main"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            selectedItem?.KPI ||
                                            'No KPI available.',
                                        }}
                                      ></div>
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </Modal>
                  </div>
                </TabPane>
                <TabPane tabId="2">
                  <div>
                    <DataGridDemo
                      columns={[
                        {
                          field: 'id',
                          headerName: 'S.No',
                          width: 100,
                          align: 'center',
                          headerAlign: 'left',
                          sortable: false, // Prevent sorting on S.No
                          renderCell: (params) =>
                            params.api.getRowIndexRelativeToVisibleRows(
                              params.id,
                            ) + 1,
                        },
                        {
                          field: 'file_name',
                          headerName: 'File Name',
                          minWidth: 400,
                          flex: 1,
                        },
                        {
                          field: 'call_quality_score',
                          headerName: 'Call Quality Score',
                          width: 200,
                          align: 'center',
                          headerAlign: 'left',
                        },

                        {
                          field: 'performance',
                          headerName: 'Performance',
                          width: 200,
                        },
                        {
                          field: 'duration',
                          headerName: 'Duration (Min)',
                          width: 200,
                        },
                        { field: 'created_on', headerName: 'Date', width: 300 },
                        {
                          field: 'view',
                          headerName: 'View',
                          width: 200,
                          align: 'center',
                          headerAlign: 'center',

                          sortable: false,
                          renderCell: (params) => (
                            <IconButton
                              onClick={() => handleViewClick(params.row)}
                              color="primary"
                              type="button"
                              className="conv-view-btn"
                            >
                              <VisibilityIcon />
                            </IconButton>
                          ),
                        },
                      ]}
                      rows={formattedvideoDataArray}
                      // onRowClick={handleRowClick}
                    />

                    <Modal
                      size="xl"
                      isOpen={modal_center1}
                      toggle={() => {
                        tog_center1();
                      }}
                      centered
                      className="video-trans-model"
                    >
                      <div className="modal-header">
                        <div className="video-trans">
                          <h4 className="modal-title f-18">
                            {selectedItem?.file_name}
                          </h4>
                          <p>Video Call Transcript</p>
                          <p className="bold">
                            Student Name: {selectedItem?.student_name}
                          </p>
                          <p className="bold">
                            Teacher Name: {selectedItem?.teacher_name}
                          </p>
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            setmodal_center1(false);
                            setSelectedItem(null);
                          }}
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body modal-bg-grey">
                        {selectedItem && customActiveTab === '2' && (
                          <div className="video-chat-container justify-content-between mt-0 ">
                            <div className="floating-video-player mt-0 ">
                              {
                                !selectedItem.video_file?
                                <p>Session recording not available </p>:
                              <video
                                src={selectedItem.video_file}
                                controlsList="nodownload"
                                controls
                                style={{ borderRadius: '10px' }}
                              />
                              }
                            </div>

                            <div className="video-transcript-tab" style={{
                              height:"100%"
                            }}>
                              <Nav
                                className="mb-0 nav-tabs-custom  nav-tabs"
                                tabVideo
                              >
                                <NavItem className="ms-0 me-1">
                                  <NavLink
                                    className={
                                      activeTabVideo === 'transcriptionvideo'
                                        ? 'active'
                                        : ''
                                    }
                                    active={
                                      activeTabVideo === 'transcriptionvideo'
                                    }
                                    onClick={() =>
                                      toggleTabVideo('transcriptionvideo')
                                    }
                                    style={{
                                      cursor: 'pointer',
                                      marginRight: '2px',
                                    }}
                                  >
                                    Call Transcript
                                  </NavLink>
                                </NavItem>
                                <NavItem className="ms-0 me-1">
                                  <NavLink
                                    className={
                                      activeTabVideo === 'summary'
                                        ? 'active'
                                        : ''
                                    }
                                    active={activeTabVideo === 'summary'}
                                    onClick={() => toggleTabVideo('summary')}
                                    style={{
                                      cursor: 'pointer',
                                      marginRight: '3px',
                                    }}
                                  >
                                    Call Summary
                                  </NavLink>
                                </NavItem>
                                <NavItem className="ms-0 me-1">
                                  <NavLink
                                    className={
                                      activeTabVideo === 'topics'
                                        ? 'active'
                                        : ''
                                    }
                                    active={activeTabVideo === 'topics'}
                                    onClick={() => toggleTabVideo('topics')}
                                    style={{
                                      cursor: 'pointer',
                                      marginRight: '3px',
                                    }}
                                  >
                                    Topics Discussed
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={
                                      activeTabVideo === 'callqualityvideo'
                                        ? 'active'
                                        : ''
                                    }
                                    active={
                                      activeTabVideo === 'callqualityvideo'
                                    }
                                    onClick={() =>
                                      toggleTabVideo('callqualityvideo')
                                    }
                                    style={{
                                      cursor: 'pointer',
                                      marginRight: '3px',
                                    }}
                                  >
                                    Call Quality
                                  </NavLink>
                                </NavItem>

                                {/* <NavItem className="mx-0">
                                  <NavLink
                                    className={activeTabVideo === "kpi" ? "active" : ""}
                                    active={activeTabVideo === "kpi"}
                                    onClick={() => toggleTabVideo("kpi")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    KPI
                                  </NavLink>
                                </NavItem> */}
                              </Nav>

                              <div>
                                {activeTabVideo === 'transcriptionvideo' && (
                                  // <div>
                                  //   <div>
                                  //     <p><strong>Transcription:</strong></p>
                                  //     <p>The conversation between the facilitator (Michelle McBride) and the student (Annie May) focused on organizing a follow-up call, discussing office hours, and ensuring that the student is aware of important details for her assessments. The student expressed concerns about her busy schedule, mentioning her full-time job as a teacher and personal responsibilities. They agreed on a follow-up call on Friday at 7:30 PM, and the facilitator assured support for the student’s situation.</p>
                                  //     <p><strong>Duration:</strong> 9.74 minutes</p>
                                  //     <p><strong>Topics discussed:</strong></p>
                                  //     <ul>
                                  //       <li>Follow-up call</li>
                                  //       <li>Office hours</li>
                                  //       <li>Assessments</li>
                                  //       <li>Student's schedule</li>
                                  //       <li>Teacher's support</li>
                                  //     </ul>
                                  //   </div>
                                  // </div>
                                  <div className="audio chat-container">
                                    <div className=" d-flex flex-column">
                                      {selectedItem.transcription.map(
                                        (line, index) => (
                                          <div
                                            key={index}
                                            className={`chat-bubble ${line.speakerClass}`}
                                          >
                                            <strong>{line.speaker}</strong>
                                            <br />
                                            {line.line}
                                            <br />
                                            <span>
                                              {line.starttime}s - {line.endtime}
                                              s
                                            </span>
                                            {}
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  </div>
                                )}
                                {activeTabVideo === 'summary' && (
                                  <div className="trans-tab-content">
                                    <p className="f-16 bold mb-1">
                                      Call Summary:
                                    </p>
                                    {/* <p>{selectedItem?.summary}</p> */}
                                    <div
                                      className="va-summary-main"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          selectedItem?.summary?.call_summary ||
                                          'No summary available.',
                                      }}
                                    ></div>
                                    <h4 className="bold mt-2">
                                      Discussion Points
                                    </h4>
                                    <div className="mt-2">
                                      <table className="bordered-table">
                                        <tbody>
                                          {/* {rows.map((row, index) => (
                                            <tr key={index}>
                                              <td className="pointer  align-items-center gap-2" style={{ position: "relative" }}>
                                                {row.label}
                                                <span
                                                  onMouseEnter={() => setHoveredIndex(index)}
                                                  onMouseLeave={() => setHoveredIndex(null)}
                                                  style={{ position: "relative", display: "inline-block", cursor: "pointer" }}
                                                >
                                                  <FaInfoCircle />
                                                  {hoveredIndex === index && (
                                                    <span className="tooltip-box">{row.title}</span>
                                                  )}
                                                </span>
                                              </td>
                                              <td>{row.value}</td>
                                            </tr>
                                          ))} */}
                                          {rows.map((row, index) => (
                                            <tr key={index}>
                                              <td>
                                                <span
                                                  className="position-relative d-inline-block"
                                                  onMouseEnter={() =>
                                                    setHoveredIndex(index)
                                                  }
                                                  onMouseLeave={() =>
                                                    setHoveredIndex(null)
                                                  }
                                                  style={{ cursor: 'pointer' }}
                                                >
                                                  {row.label}
                                                  {hoveredIndex === index && (
                                                    <span className="tooltip-box">
                                                      {row.title}
                                                    </span>
                                                  )}
                                                </span>
                                              </td>
                                              <td>{row.value}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                    <h4 className="bold mt-2">
                                      {' '}
                                      Knowledge Gaps Identified / Common Doubts
                                      Raised by student{' '}
                                    </h4>
                                    <div
                                      className="va-summary-main"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          selectedItem?.knowledge_gaps_identified ||
                                          'No summary available.',
                                      }}
                                    ></div>
                                  </div>
                                )}
                                {activeTabVideo === 'topics' && (
                                  <div className="trans-tab-content">
                                    <p className="f-16 bold mb-1">
                                      Topics Discussed:
                                    </p>
                                    <ul>
                                      {topicsDiscussedVideo &&
                                        Object.entries(
                                          topicsDiscussedVideo,
                                        ).map(([topicName, qas], index) => (
                                          <div key={index} className="mb-3">
                                            <h5>{topicName}</h5>
                                            {qas.map((qa, qaIndex) => (
                                              <div
                                                key={qaIndex}
                                                className="mb-2"
                                              >
                                                <p>
                                                  <strong>Q:</strong>{' '}
                                                  {qa.question}
                                                </p>
                                                <p>
                                                  <strong>A:</strong>{' '}
                                                  {qa.answer}
                                                </p>

                                                {/* Show A Mark if is_assessment_related is true */}
                                                {qa.is_assessment && (
                                                  <p className="text-success">
                                                    <strong>A :</strong> ✓
                                                    Assessment Related
                                                  </p>
                                                )}
                                              </div>
                                            ))}
                                          </div>
                                        ))}
                                    </ul>
                                  </div>
                                )}
                                {activeTabVideo === 'callqualityvideo' && (
                                  <div className="trans-tab-content">
                                    <p className="f-16 mb-2">
                                      <strong>Call Quality:</strong>
                                    </p>

                                    <h5 className="f-16 d-flex  bold mb-3 ">
                                      Call Quality Rubric{' '}
                                    </h5>
                                    <HighchartsReact
                                      highcharts={Highcharts}
                                      options={progressOptions}
                                    />
                                    <h5 className="f-16 d-flex  bold mb-3 ">
                                      Session KPI:{' '}
                                    </h5>

                                    <div
                                      className="va-summary-main"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          selectedItem?.callQualityKpi ||
                                          'No Call Quality Available.',
                                      }}
                                    ></div>
                                  </div>
                                )}

                                {activeTabVideo === 'kpi' && (
                                  <div className="trans-tab-content">
                                    <h5 className="f-16 d-flex  bold mb-3 ">
                                      Session KPI:{' '}
                                    </h5>

                                    <ul>
                                      <div
                                        className="va-summary-main"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            selectedItem?.KPI ||
                                            'No KPI available.',
                                        }}
                                      ></div>
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </Modal>
                  </div>
                </TabPane>
                <TabPane tabId="3">
                  <div
                    className="d-flex justify-content-center"
                    style={{ backgroundColor: '#f7f7f7' }}
                  >
                    <div className="chat-view ">
                      <div className="chat-container">
                        {Object.keys(groupedMessages).map((date) => (
                          <div key={date} className="chat-messages-group">
                            <div className="chat-date">{date}</div>
                            {groupedMessages[date].map((msg) => (
                              <div key={msg.id} className="chat-messages1">
                                <div
                                  className={`chat-bubble1 ${
                                    msg.sender === 'User A'
                                      ? 'user-a1'
                                      : 'user-b1'
                                  }`}
                                >
                                  <div className="chat-content">
                                    <div>
                                      <p
                                        className="bold"
                                        style={{ color: '000' }}
                                      >
                                        {msg.name}
                                      </p>
                                    </div>
                                    {msg.content}
                                  </div>
                                  <div className="chat-time">{msg.date}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </TabPane>

                <TabPane tabId="4">
                  <div className="mail-menu-container">
                    {expandedMailSection === 'all' && (
                      <DataGridDemo
                        columns={[
                          {
                            field: 'sno',
                            headerName: 'S.No',
                            width: 110,
                            align: 'center',
                            headerAlign: 'left',
                          },
                          { field: 'date', headerName: 'Date', width: 300 },
                          {
                            field: 'subject',
                            headerName: 'Subject',
                            flex: 1,
                            minWidth: 450,
                          },
                          {
                            field: 'view',
                            headerName: 'View',
                            width: 150,
                            align: 'center',
                            headerAlign: 'center',
                            renderCell: (params) => (
                              <button
                                style={{
                                  color: 'blue',
                                  background: 'none',
                                  border: 'none',
                                  cursor: 'pointer',
                                  textDecoration: 'underline',
                                }}
                              >
                                <IconButton
                                  onClick={() =>
                                    handleThreadView(params.row.threadId)
                                  }
                                  color="primary"
                                  type="button"
                                  className="conv-view-btn"
                                >
                                  <VisibilityIcon />
                                </IconButton>
                              </button>
                            ),
                          },
                        ]}
                        rows={formatMails.map((thread, index) => ({
                          sno: index + 1,
                          id: thread.threadId,
                          threadId: thread.threadId,
                          date: thread.date,
                          subject: thread.subject,
                        }))}
                      />
                    )}
                  </div>
                  {/* <Modal
                    size="md"
                    isOpen={modalCenter2}
                    toggle={() => setModalCenter2(false)}
                    centered
                  >
                    <div className="modal-header">
                      <div>
                        <h4 className="f-18">{selectedThread?.subject}</h4>
                        <p>Mail Details</p>
                      </div>
                      <button
                        type="button"
                        onClick={() => {
                          setModalCenter2(false);
                          setSelectedThread(null);
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {selectedThread && (
                        <div className="video-chat-container mt-0">
                          <div className="transcript w-100 ms-0">
                            <ul className="ps-0">
                              <div className="chat-container bg-white p-0">
                                <div className="d-flex flex-column">
                                  <div className="mail-details">
                                    {selectedThread.emails.map(
                                      (email, index) => (
                                        <div key={index} className="mail-item">
                                          <h5>
                                            {email.mail_from} to {email.mail_To}
                                          </h5>
                                          <p>
                                            <strong>Subject:</strong>{" "}
                                            {email.subject}
                                          </p>
                                          <p>
                                            <strong>Date:</strong> {email.date}
                                          </p>
                                          <p>{email.body}</p>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </ul>
                          </div>
                        </div>
                      )}
                    </div>
                  </Modal> */}
                  <Modal
                    size="lg"
                    isOpen={modalCenter2}
                    toggle={() => setModalCenter2(false)}
                    centered
                  >
                    <div className="modal-header">
                      <div>
                        <p>Mail Details</p>
                      </div>
                      <button
                        type="button"
                        onClick={() => {
                          setModalCenter2(false);
                          setSelectedThread(null);
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {selectedThread && (
                        <div className="intrac-email-wrapper">
                          <Row>
                            <Col sm="12">
                              {/* Loop through each email in the selected thread */}
                              {selectedThread.emails.map((email, index) => (
                                <div key={index} className="email-items">
                                  <div
                                    className={`sen-rec-info ${
                                      email.type === 'sent' ? 'sent' : 'receive'
                                    }`}
                                  >
                                    <h6
                                      className={
                                        email.type === 'sent'
                                          ? 'sent'
                                          : 'receive'
                                      }
                                    >
                                      {email.type === 'sent'
                                        ? 'Sent'
                                        : 'Received'}
                                    </h6>
                                    <p>{email.date}</p>
                                  </div>
                                  <div className="email-ctn">
                                    <h4>{email.subject}</h4>
                                    {/* <p>{email.body}</p> */}
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          email?.body ||
                                          'No body content available',
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              ))}
                            </Col>
                          </Row>
                        </div>
                      )}
                    </div>
                  </Modal>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default StarterPage;
